import { request } from "@/utils/request";

export function Add(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/Add",
    params,
  });
}

export function Modify(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/Modify",
    params,
  });
}

export function Del(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/Del",
    params,
  });
}

export function GetItemById(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Channel/GetItemById",
    params,
  });
}

export function AddContent(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/AddContent",
    params,
  });
}

export function ModifyContent(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/ModifyContent",
    params,
  });
}

export function SortContent(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/SortContent",
    params,
  });
}

export function TrashContent(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/TrashContent",
    params,
  });
}

export function RecoverContent(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/RecoverContent",
    params,
  });
}

export function DelContent(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Channel/DelContent",
    params,
  });
}

export function GetContentItem(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Channel/GetContentItem",
    params,
  });
}

export function GetContentList(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Channel/GetContentList",
    params,
  });
}

export function GetContentTreeList(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Channel/GetContentTreeList",
    params,
  });
}

export function GetContentPage(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Channel/GetContentPage",
    params,
  });
}

export function GetRecyclePage(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Channel/GetRecyclePage",
    params,
  });
}

export function ExportExcelData(params = {}) {
  return request({
    method: "getFile",
    url: "/adminApi/Channel/ExportExcelData",
    params,
  });
}

export function GetImportTemplate(params={}){
  return request({
    method: "getFile",
    url: "/adminApi/Channel/GetImportTemplate",
    params,
  });
}

export function ImportExcelData(params = {}) {
  return request({
    method: "file",
    url: "/adminApi/Channel/ImportData",
    params,
  });
}
